import {BrowserModule} from '@angular/platform-browser';
import {APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgxSliderModule} from '@angular-slider/ngx-slider';
import {ToasterModule} from 'angular2-toaster';
import {StompService} from 'ng2-stomp-service';
import {NgxJsonViewerModule} from 'ngx-json-viewer';
import {FileUploadModule} from 'ng2-file-upload';
import {GridsterModule} from 'angular-gridster2';
import {AuthServiceConfig, GoogleLoginProvider} from 'angularx-social-login';
import {MarkdownModule, MarkedOptions} from 'ngx-markdown';
import {TreeModule} from 'angular-tree-component';
import {ChartModule} from 'angular2-chartjs';
import {ChartsModule} from 'ng2-charts';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatGridListResponsiveModule} from 'src/app/utility/grid/mat-grid-list-responsive.module';
import {AngularResizedEventModule} from 'angular-resize-event';
import {MatExpansionModule} from '@angular/material/expansion';

import * as $ from 'jquery';

import {} from 'jasmine';

import {AppRoutingDashboardModule} from '../modules/app-routing-dashboard.module';
import {AppRoutingBillingModule} from '../modules/app-routing-billing.module';
import {AppRoutingSettingModule} from '../modules/app-routing-setting.module';
import {AppRoutingResourceModule} from '../modules/app-routing-resource.module';
import {AppRoutingSoftwareModule} from '../modules/app-routing-software.module';
import {AppRoutingServiceModule} from '../modules/app-routing-service.module';
import {AppRoutingMonitoringModule} from '../modules/app-routing-monitoring.module';
import {AppRoutingBoardModule} from '../modules/app-routing-board.module';
import {AppRoutingMarketModule} from 'src/modules/app-routing-market.module';
import {AppRoutingOrderModule} from 'src/modules/app-routing-order.module';
import {AppRoutingModule} from '../modules/app-routing.module';
import {AppRoutingMenuModule} from '../modules/app-routing-menu.module';
import {AppRoutingMeteringModule} from '../modules/app-routing-metering.module';
import {AppRoutingCloudAccountModule} from '../modules/app-routing-cloud-account.module';
import {AppRoutingChatbotModule} from '../modules/app-routing-chatbot.module';

import {AppTranslationModule} from '../modules/translation.module';
import {MaterialModule} from '../modules/material.module';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';

import {FullscreenOverlayContainer, OverlayContainer} from '@angular/cdk/overlay';
import {CodemirrorModule} from 'ng2-codemirror';

import {AppRootComponent} from './app.root';
import {AppComponent} from './app.component';
import {MenuComponent} from './layout/menu/menu.component';
import {MenuSubSideComponent} from './layout/menu/toplist/subside/subside.component';
import {NavigationComponent} from './layout/navigation/navigation.component';

import {HomeComponent} from './dashboard/home/home.component';
import {HomeLogoutComponent} from './dashboard/home/home.logout.component';

import {CountUpModule} from 'ngx-countup';

import {MainComponent} from './dashboard/main/main.component';
import {ContentComponent} from './layout/content/content.component';
import {TopMenuListComponent} from './layout/menu/toplist/toplist.component';
import {TopMenuPopupComponent} from './layout/menu/toppopup/toppopup.component';

import {FileSizePipe} from './utility/pipes/file-size.pipe';
import {UserProfileImagePipe} from './utility/pipes/user.profile.pipe';

import {TaskScheduleListComponent} from './setting/task/scheduler/list/list.component';
import {TaskScheduleDetailComponent} from './setting/task/scheduler/detail/detail.component';
import {TaskScheduleVariableListComponent} from './setting/task/scheduler/variable/list/list.component';
import {TaskScheduleVariableDetailComponent} from './setting/task/scheduler/variable/detail/detail.component';
import {TaskScheduleVariableContentComponent} from './setting/task/scheduler/variable/content/content.component';
import {ValueInputDialog} from './setting/task/scheduler/variable/value.dialog';

import {MemberLayoutComponent} from './setting/member/layout/layout.component';
import {MemberLoginComponent} from './setting/member/login/login.component';
import {MemberRegisterComponent} from './setting/member/register/register.component';

import {LocaleComponent} from './member/locale/locale.component';
import {SignInComponent} from './member/signin/signin.component';
import {SignUpComponent} from './member/signup/signup.component';

import {ServiceCatalogListComponent} from './service/catalog/list/list.component';
import {ServiceCatalogLauncherComponent} from './service/catalog/launcher/launcher.component';

import {SchedulerListComponent} from './service/scheduler/list/list.component';
import {SchedulerDetailComponent} from './service/scheduler/detail/detail.component';
import {SchedulerRuleComponent} from './service/scheduler/rule/rule.component';
import {SchedulerHistoryComponent} from './service/scheduler/history/history.component';
import {SchedulerTaskComponent} from './service/scheduler/task/task.component';
import {SchedulerCalendarComponent} from './service/scheduler/calendar/calendar.component';

import {TaskConfigVariableDialog} from './service/scheduler/task/task.config.variable.dialog';

import {ProjectListComponent} from './service/project/list/list.component';
import {ProjectDetailComponent} from './service/project/detail/detail.component';

import {ChangePasswordComponent} from './member/change-password/change.password.component';

import {environment} from 'src/environments/environment';
import {AppConfigService} from './app-config.service';

import {SerengetiBillingModule} from '@serengeti/serengeti-billing';
import {SerengetiBoardModule} from '@serengeti/serengeti-board';
import {SerengetiChatModule} from '@serengeti/serengeti-chat';
import {SerengetiSurveyModule} from '@serengeti/serengeti-survey';
import {SerengetiTokenModule} from '@serengeti/serengeti-token';
import {SerengetiMonacoEditorModule} from '@serengeti/serengeti-editor';
import {SerengetiMindslabModule} from '@serengeti/serengeti-mindslab';
import {SerengetiCommonModule} from '@serengeti/serengeti-common';
import {markedOptionsFactory, SerengetiMarketModule} from '@serengeti/serengeti-market';
import {SerengetiOrderModule} from '@serengeti/serengeti-order';
import {SerengetiMailerModule} from '@serengeti/serengeti-mailer';
import {SerengetiLoginModule} from '@serengeti/serengeti-login';
import {SerengetiAppModule} from '@serengeti/serengeti-app';
import {SerengetiResourceModule} from '@serengeti/serengeti-resource';
import {SerengetiNotificationModule} from '@serengeti/serengeti-notification';
import {SerengetiMonitoringModule} from '@serengeti/serengeti-monitoring';
import {SerengetiTaskModule} from '@serengeti/serengeti-task';
import {SerengetiDashboardModule} from '@serengeti/serengeti-dashboard';
import {SerengetiMeteringModule} from '@serengeti/serengeti-metering';
import {SerengetiCodeModule} from '@serengeti/serengeti-code';
import {SerengetiConfigModule} from '@serengeti/serengeti-config';
import {SerengetiCloudAccountModule} from '@serengeti/serengeti-cloud-account';
import {SerengetiMenuModule} from '@serengeti/serengeti-menu';
import {SerengetiUserModule} from '@serengeti/serengeti-user';
import { SerengetiChatbotModule } from '@serengeti/serengeti-chatbot';

import {MarketProductCreateComponent} from './market/product/create/create.component';
import {MarketProductDetailComponent} from './market/product/detail/detail.component';
import {LogListComponent} from './setting/log/list/list.component';
import {SerengetiDatastoreModule} from '@serengeti/serengeti-datastore';
import {MultiTranslateHttpLoader} from 'ngx-translate-multi-http-loader';
import {ThemeService} from './setting/theme/service/theme.service';
import {SideMenuPopupComponent} from './layout/menu/sidepopup/sidepopup.component';
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material';

import {WizardMarketNewComponent} from './dashboard/widgets/wizard-market-new/wizard-market-new.component';
import {
  WizardMarketFavoriteComponent
} from './dashboard/widgets/wizard-market-favorite/wizard-market-favorite.component';
import {
  WizardMarketDownloadComponent
} from './dashboard/widgets/wizard-market-download/wizard-market-download.component';
import {WizardMarketHistoryComponent} from './dashboard/widgets/wizard-market-history/wizard-market-history.component';
import {WizardMarketSearchComponent} from './dashboard/widgets/wizard-market-search/wizard-market-search.component';
import {WizardResourceStatComponent} from './dashboard/widgets/wizard-resource-stat/wizard-resource-stat.component';
import {WizardResourceCloudComponent} from './dashboard/widgets/wizard-resource-cloud/wizard-resource-cloud.component';
import {WizardResourceMapComponent} from './dashboard/widgets/wizard-resource-map/wizard-resource-map.component';
import {
  WizardServiceCalendarComponent
} from './dashboard/widgets/wizard-service-calendar/wizard-service-calendar.component';
import {
  WizardNotificationHistoryComponent
} from './dashboard/widgets/wizard-notification-history/wizard-notification-history.component';
import {WizardOrderStatComponent} from './dashboard/widgets/wizard-order-stat/wizard-order-stat.component';

import {SoftwareCatalogLauncherComponent} from './software/catalog/launcher/launcher.component';
import {
  WizardMonitoringProblemsComponent
} from './dashboard/widgets/wizard-monitoring-problems/wizard-monitoring-problems.component';
import {
  WizardMonitoringAverageComponent
} from './dashboard/widgets/wizard-monitoring-average/wizard-monitoring-average.component';
import {
  WizardMonitoringDialogComponent
} from './dashboard/widgets/wizard-monitoring-average/monitoring-dialog/monitoring-dialog.component';
import {AppRoutingApiManagerModule} from '../modules/app-routing-api-manager.module';
import {SerengetiAPIManagerModule} from '@serengeti/serengeti-api-manager';
import {DpgSubInfoComponent} from './dashboard/dpg/info/info.component';
import {DpgSubNoticeComponent} from './dashboard/dpg/notice/notice.component';
import {SsoComponent} from './member/signin/sso/sso.component';
import { WizardApiDummyComponent } from './dashboard/widgets/wizard-api-dummy/wizard-api-dummy.component';
import { WizardApiRegisteredComponent } from './dashboard/widgets/wizard-api-registered/wizard-api-registered.component';
import { WizardUserInfoComponent } from './dashboard/widgets/wizard-user-info/wizard-user-info.component';
import { WizardTestBedComponent } from './dashboard/widgets/wizard-test-bed/wizard-test-bed.component';
import { ConsoleCloudAccountListComponent } from './cloud-account/list/list.component';
import { ConsoleCloudAccountPoolSetupDialog } from './cloud-account/pool/pool.dialog';
import { ConsoleCloudAccountPoolCreateComponent } from './cloud-account/pool/create/create.component';
import { ConsoleCloudAccountPoolSelectComponent } from './cloud-account/pool/select/select.component';
import { SliderComponent } from './dashboard/home/slider/slider.component';



export function createTranslateLoader(http: HttpClient) {
	return new MultiTranslateHttpLoader(http, [
		{ prefix: 'assets/i18n/common/', suffix: '.json' },
		{ prefix: 'assets/i18n/home/', suffix: '.json' },
		{ prefix: 'assets/i18n/service/', suffix: '.json' },
		{ prefix: 'assets/i18n/setting/', suffix: '.json' },
		{ prefix: 'assets/i18n/market/', suffix: '.json' },
		{ prefix: 'assets/i18n/etc/', suffix: '.json' },
		{ prefix: 'assets/i18n/dashboard/', suffix: '.json' },
		{ prefix: 'assets/i18n/sidepopup/', suffix: '.json' },
		{ prefix: 'assets/i18n/software/', suffix: '.json' },
		{ prefix: 'assets/i18n/cloud-account/', suffix: '.json' },

		{ prefix: 'assets/i18n/serengeti-config/config/', suffix: '.json' },
		{ prefix: 'assets/i18n/serengeti-code/code/', suffix: '.json' },
		{ prefix: 'assets/i18n/serengeti-common/common/', suffix: '.json' },
		{ prefix: 'assets/i18n/serengeti-remote-console/console/', suffix: '.json' },
		{ prefix: 'assets/i18n/serengeti-notification/notification/', suffix: '.json' },
		{ prefix: 'assets/i18n/serengeti-monitoring/monitoring/', suffix: '.json' },
		{ prefix: 'assets/i18n/serengeti-task/task/', suffix: '.json' },
		{ prefix: 'assets/i18n/serengeti-resource/resource/', suffix: '.json' },
		{ prefix: 'assets/i18n/serengeti-resource/clouddriver/ktgov/', suffix: '.json' },
		{ prefix: 'assets/i18n/serengeti-resource/clouddriver/openstack/', suffix: '.json' },
		{ prefix: 'assets/i18n/serengeti-resource/clouddriver/vmware/', suffix: '.json' },
		{ prefix: 'assets/i18n/serengeti-resource/clouddriver/aws/', suffix: '.json' },
		{ prefix: 'assets/i18n/serengeti-resource/clouddriver/k8s/', suffix: '.json' },
		{ prefix: 'assets/i18n/serengeti-resource/clouddriver/ncp/', suffix: '.json' },
		{ prefix: 'assets/i18n/serengeti-resource/clouddriver/gcp/', suffix: '.json' },
		{ prefix: 'assets/i18n/serengeti-resource/clouddriver/scp/', suffix: '.json' },
		{ prefix: 'assets/i18n/serengeti-resource/clouddriver/nhn/', suffix: '.json' },
    { prefix: 'assets/i18n/serengeti-resource/clouddriver/ucloud/', suffix: '.json' },
    { prefix: 'assets/i18n/serengeti-resource/clouddriver/legacy/', suffix: '.json' },
    { prefix: 'assets/i18n/serengeti-resource/clouddriver/kakao/', suffix: '.json' },
		{ prefix: 'assets/i18n/serengeti-app/software/', suffix: '.json' },
		{ prefix: 'assets/i18n/serengeti-market/market/', suffix: '.json' },
		{ prefix: 'assets/i18n/serengeti-order/order/', suffix: '.json' },
		{ prefix: 'assets/i18n/serengeti-order/process/', suffix: '.json' },
		{ prefix: 'assets/i18n/serengeti-order/form/', suffix: '.json' },
		{ prefix: 'assets/i18n/serengeti-board/board/', suffix: '.json' },
		{ prefix: 'assets/i18n/serengeti-chat/chat/', suffix: '.json' },
		{ prefix: 'assets/i18n/serengeti-survey/survey/', suffix: '.json' },
		{ prefix: 'assets/i18n/serengeti-token/token/', suffix: '.json' },
		{ prefix: 'assets/i18n/serengeti-mailer/common/', suffix: '.json' },
		{ prefix: 'assets/i18n/serengeti-mailer/mailer/', suffix: '.json' },
		{ prefix: 'assets/i18n/serengeti-mindslab/mindslab/', suffix: '.json' },
		{ prefix: 'assets/i18n/serengeti-editor/editor/', suffix: '.json' },
		{ prefix: 'assets/i18n/serengeti-login/login/', suffix: '.json' },
		{ prefix: 'assets/i18n/serengeti-datastore/datastore/', suffix: '.json' },
		{ prefix: 'assets/i18n/serengeti-dashboard/dashboard/', suffix: '.json' },
		{ prefix: 'assets/i18n/serengeti-menu/config/', suffix: '.json' },
		{ prefix: 'assets/i18n/serengeti-user/user/', suffix: '.json' },
		{ prefix: 'assets/i18n/serengeti-billing/billing/', suffix: '.json' },
		{ prefix: 'assets/i18n/serengeti-metering/metering/', suffix: '.json' },
		{ prefix: 'assets/i18n/serengeti-cloud-account/cloud-account/', suffix: '.json' },
		{ prefix: 'assets/i18n/serengeti-api-manager/api-manager/', suffix: '.json' },

		{ prefix: 'assets/i18n/custom/', suffix: '.json' },
  	]);
}

// Application wide providers
const APP_PROVIDERS = [
];

const appInitializerFn = (
	appConfig: AppConfigService,
	themeService: ThemeService) => {
	return () => {
		const config = appConfig.loadAppConfig();

		environment.serviceThemeObject = themeService.changed();

  		return config;
	};
};

const config = new AuthServiceConfig([
	{
	  id: GoogleLoginProvider.PROVIDER_ID,
	  provider: new GoogleLoginProvider('895127368544-bcgbe8btptm1qsqv0lqltr0oo4mhj78p.apps.googleusercontent.com')
	}
  ]);

export function provideConfig() {
	return config;
}

export function getSubServiceActiveState(serviceName: string) {
	if (environment.content) {
		if (environment.content.disabled_services) {
			if (environment.content.disabled_services.includes(serviceName)) {
				return false;
			}
		}
	}
	return true;
}

export function getChatActiveState() {
	return getSubServiceActiveState('api.chat');
}


export function getDashboardActiveState() {
	return getSubServiceActiveState('api.dashboard');
}

export function getOauthLoginActiveState() {
	return getSubServiceActiveState('api.oauth');
}

export function getTokenActiveState() {
	return getSubServiceActiveState('api.token');
}

export function getConsoleTheme() {
    if (!localStorage.getItem(ThemeService.themeProperty)) {
		return environment.serviceTheme;
	} else {
		return localStorage.getItem(ThemeService.themeProperty);
	}
}

@NgModule({
	declarations: [
		AppRootComponent,
		AppComponent,
		MenuComponent,
		HomeComponent,
		HomeLogoutComponent,
		MenuSubSideComponent,
		ContentComponent,
		TopMenuListComponent,
		TopMenuPopupComponent,
		NavigationComponent,
		FileSizePipe,
		UserProfileImagePipe,

		SoftwareCatalogLauncherComponent,

		// User & Login Management
		TaskScheduleListComponent,
		TaskScheduleDetailComponent,
		TaskScheduleVariableListComponent,
		TaskScheduleVariableDetailComponent,
		TaskScheduleVariableContentComponent,
		ValueInputDialog,

		MemberLayoutComponent,
		MemberLoginComponent,
		MemberRegisterComponent,
		MainComponent,

		LocaleComponent,
		SignInComponent,
		SignUpComponent,
		ChangePasswordComponent,

		// Service Catalog, Project & Scheduler
		ServiceCatalogListComponent,
		ServiceCatalogLauncherComponent,

		ProjectListComponent,
		ProjectDetailComponent,

		SchedulerListComponent,
		SchedulerDetailComponent,
		SchedulerHistoryComponent,
		SchedulerRuleComponent,
		SchedulerTaskComponent,
		SchedulerCalendarComponent,
		TaskConfigVariableDialog,

		MarketProductCreateComponent,
		MarketProductDetailComponent,

		LogListComponent,

		SideMenuPopupComponent,

		DpgSubInfoComponent,
		DpgSubNoticeComponent,
		SsoComponent,

		WizardMarketNewComponent,
		WizardMarketFavoriteComponent,
		WizardMarketDownloadComponent,
		WizardMarketHistoryComponent,
		WizardMarketSearchComponent,
		WizardResourceStatComponent,
		WizardResourceMapComponent,
		WizardResourceCloudComponent,
		WizardNotificationHistoryComponent,
		WizardServiceCalendarComponent,
		WizardOrderStatComponent,
		WizardMonitoringProblemsComponent,
		WizardMonitoringAverageComponent,
		WizardMonitoringDialogComponent,
		WizardApiDummyComponent,
		WizardApiRegisteredComponent,
		WizardUserInfoComponent,
		WizardTestBedComponent,

		ConsoleCloudAccountListComponent,
		ConsoleCloudAccountPoolSetupDialog,
		ConsoleCloudAccountPoolCreateComponent,
		ConsoleCloudAccountPoolSelectComponent,
		SliderComponent,
	],
	imports: [
		CountUpModule,
		BrowserModule,
		FormsModule,
		NgxSliderModule,
		AppTranslationModule,
		AppRoutingModule,
		AppRoutingResourceModule,
		AppRoutingSoftwareModule,
		AppRoutingSettingModule,
		AppRoutingBillingModule,
		AppRoutingDashboardModule,
		AppRoutingServiceModule,
		AppRoutingMonitoringModule,
    AppRoutingMenuModule,
		AppRoutingBoardModule,
		AppRoutingMeteringModule,
		AppRoutingApiManagerModule,
		AppRoutingMarketModule,
		AppRoutingOrderModule,
		AppRoutingCloudAccountModule,
		AppRoutingChatbotModule,
		MaterialModule,
		DragDropModule,
		HttpClientModule,
		BrowserAnimationsModule,
		CodemirrorModule,
		NgbModule,
		BrowserAnimationsModule,
		ToasterModule.forRoot(),
		NgxJsonViewerModule,
		FileUploadModule,
    	MarkdownModule.forRoot({
      loader: HttpClient,
    }),

		TreeModule.forRoot(),
		MatExpansionModule,
		ChartModule,
		MatTooltipModule,
		MatSlideToggleModule,
		MatGridListResponsiveModule,
		ChartsModule,
		AngularResizedEventModule,
		MarkdownModule.forRoot({
			loader: HttpClient, // optional, only if you use [src] attribute
			markedOptions: {
				provide: MarkedOptions,
				useFactory: markedOptionsFactory,
				useValue: {
				gfm: true,
				breaks: false,
				pedantic: false,
				smartLists: true,
				smartypants: false,
				},
			}
		}),
		SerengetiAPIManagerModule.forRoot({
			getThemeObserver: () => environment.serviceThemeObject,
			createTranslateLoader: createTranslateLoader,
			getLoginEndPoint: () => environment.serviceMemberEndPoint,
			getApiManagerEndPoint: () => environment.serviceApiManagerEndPoint,
      		getAppEndPoint: () => environment.serviceApplicationCoreEndPoint,
			getAppDevEndPoint: () => environment.serviceAppDevEndPoint
		}),
		SerengetiMeteringModule.forRoot({
			getContent: () => environment.content,
			getTheme: getConsoleTheme,
			getThemeObserver: () => environment.serviceThemeObject,
			createTranslateLoader: createTranslateLoader,
			getLoginEndPoint: () => environment.serviceMemberEndPoint,
			getMeteringEndPoint: () => environment.serviceMeteringEndPoint
		}),
		SerengetiConfigModule.forRoot({
			createTranslateLoader: createTranslateLoader,
			getLoginEndPoint: () => environment.serviceMemberEndPoint,
			getConfigEndPoint: () => environment.serviceConfigEndPoint
		}),
		SerengetiCodeModule.forRoot({
			createTranslateLoader: createTranslateLoader,
			getLoginEndPoint: () => environment.serviceMemberEndPoint,
			getCodeEndPoint: () => environment.serviceCodeEndPoint
		}),
		SerengetiNotificationModule.forRoot({
			createTranslateLoader: createTranslateLoader,
			getEndPoint: () => environment.serviceNotificationEndPoint,
			getDomainEndPoint: () => environment.serviceDomainEndPoint,
			getLoginEndPoint: () => environment.serviceMemberEndPoint,
			getActiveState: () => true
		}),
		SerengetiMonitoringModule.forRoot({
			createTranslateLoader: createTranslateLoader,
			getTheme: getConsoleTheme,
			getEndPoint: () => environment.serviceDomainEndPoint,
			getDomainEndPoint: () => environment.serviceDomainEndPoint,
			getLoginEndPoint: () => environment.serviceMemberEndPoint,
			getResourceEndPoint: () => environment.serviceResourceCoreEndPoint,
			getNotificationEndPoint: () => environment.serviceNotificationEndPoint,
			getContent: () => environment.content,
			getActiveState: () => true,
			getThemeObserver: () => environment.serviceThemeObject,
			getUserEndPoint: () => environment.serviceUserEndPoint,
			getMonitoringEndPoint: () => environment.serviceMonitoringEndPoint
		}),
		SerengetiResourceModule.forRoot({
			createTranslateLoader: createTranslateLoader,
			getTheme: getConsoleTheme,
			getEndPoint: () => environment.serviceDomainEndPoint,
			getDomainEndPoint: () => environment.serviceDomainEndPoint,
			getLoginEndPoint: () => environment.serviceMemberEndPoint,
			getAppEndPoint: () => environment.serviceApplicationCoreEndPoint,
		    getKeycloakEndPoint: () => environment.serviceKeycloakEndPoint,
			getResourceEndPoint: () => environment.serviceResourceCoreEndPoint,
      		getPrivateResourceEndPoint: () => environment.servicePrivateResourceEndPoint,
			getFileManagerEndPoint: () => environment.serviceResourceFileEndPoint,
			getTemplateEndPoint: () => environment.serviceResourceTemplateEndPoint,
			getTaskEndPoint: () => environment.serviceResourceTaskEndPoint,
			getMonacoEndPoint: () => environment.serviceMonacoEditorEndPoint,
			getNotificationEndPoint: () => environment.serviceNotificationEndPoint,
			getCodeEndPoint: () => environment.serviceCodeEndPoint,
			getContent: () => environment.content,
			getActiveState: () => true,
			getVariableEndPoint: () => environment.serviceVariableEndPoint,
			getWebsocketExecuteEndPoint: () => environment.serviceWebSocketEndPoint,
			getThemeObserver: () => environment.serviceThemeObject,
			getUserEndPoint: () => environment.serviceUserEndPoint,
			getProjectEndPoint: () => environment.serviceProjectEndPoint,
			getConsoleEndPoint: () => environment.serviceResourceConsoleEndPoint,
			getMonitoringEndPoint: () => environment.serviceMonitoringEndPoint,
			getBillingEndPoint: () => environment.serviceBillingEndPoint,
			getServiceResourceWebsocketExecuteEndPoint: () => environment.serviceResourceWebsocketExecuteEndPoint,
			getServiceResourceMonitoringEndPoint: () => environment.serviceResourceMonitoringEndPoint,
			getProfile: () => environment.profile
		}),
		SerengetiAppModule.forRoot({
			createTranslateLoader: createTranslateLoader,
			getTheme: getConsoleTheme,
			getEndPoint: () => environment.serviceEndPoint,
			getDomainEndPoint: () => environment.serviceDomainEndPoint,
			getLoginEndPoint: () => environment.serviceMemberEndPoint,
			getAppEndPoint: () => environment.serviceApplicationCoreEndPoint,
			getExecutionEndPoint: () => environment.serviceExecutionCoreEndPoint,
			getResourceEndPoint: () => environment.serviceResourceCoreEndPoint,
			getTaskEndPoint: () => environment.serviceResourceTaskEndPoint,
			getTemplateEndPoint: () => environment.serviceResourceTemplateEndPoint,
			getMonacoEndPoint: () => environment.serviceMonacoEditorEndPoint,
			getNotificationEndPoint: () => environment.serviceNotificationEndPoint,
			getCodeEndPoint: () => environment.serviceCodeEndPoint,
			getContent: () => environment.content,
			getActiveState: () => true,
			getVariableEndPoint: () => environment.serviceVariableEndPoint,
			getWebsocketExecuteEndPoint: () => environment.serviceWebSocketEndPoint,
			getThemeObserver: () => environment.serviceThemeObject
		}),
		SerengetiBillingModule.forRoot({
			createTranslateLoader: createTranslateLoader as any,
			getLoginEndPoint: () => environment.serviceMemberEndPoint,
			getResourceEndPoint: () => environment.serviceResourceCoreEndPoint,
			getBillingEndPoint: () => environment.serviceBillingEndPoint,
			getTheme: getConsoleTheme,
			getThemeObserver: () => environment.serviceThemeObject,
			getContent: () => environment.content,
		}),
		SerengetiMonacoEditorModule.forRoot({
			createTranslateLoader: createTranslateLoader,
			getTheme: getConsoleTheme,
			getThemeObserver: () => environment.serviceThemeObject,
			getLoginEndPoint: () => environment.serviceMenuEndPoint,
			getMenuEndPoint: () => environment.serviceDomainEndPoint,
			getEndPoint: () => environment.serviceMonacoEditorEndPoint,
			getContent: () => environment.content,
			getActiveState: () => true,
		}),
		SerengetiBoardModule.forRoot({
			createTranslateLoader: createTranslateLoader,
			getLoginEndPoint: () => environment.serviceMemberEndPoint,
			getEndPoint: () => environment.serviceBoardEndPoint,
			getContent: () => environment.content
		}),
		SerengetiChatModule.forRoot({
			createTranslateLoader : createTranslateLoader,
			getLoginEndPoint: () => environment.serviceMemberEndPoint,
			getEndPoint : () => environment.serviceChatEndPoint,
			getWebSocketEndPoint : () => environment.serviceWebSocketEndPoint,
			getActiveState : getChatActiveState,
		}),
		SerengetiSurveyModule.forRoot({
			createTranslateLoader : createTranslateLoader,
			getLoginEndPoint: () => environment.serviceMemberEndPoint,
			getEndPoint : () => environment.serviceSurveyEndPoint,
			getContent: () => environment.content,
			getThemeObserver: () => environment.serviceThemeObject,
			getActiveState: () => true
		}),
		SerengetiCommonModule.forRoot({
			createTranslateLoader : createTranslateLoader,
			getProduction: () => true,
			getLoginEndPoint: () => environment.serviceMemberEndPoint,
        	getMenuEndPoint: () => environment.serviceMenuEndPoint
		}),
		SerengetiCloudAccountModule.forRoot({
			createTranslateLoader : createTranslateLoader,
			getLoginEndPoint: () => environment.serviceMemberEndPoint,
			getThemeObserver: () => environment.serviceThemeObject,
			getCloudAccountEndPoint: () => environment.serviceCloudAccountEndPoint,
			getContent: () => environment.content,
			getTheme: getConsoleTheme
		}),
		SerengetiMenuModule.forRoot({
			createTranslateLoader : createTranslateLoader,
			getLoginEndPoint: () => environment.serviceMemberEndPoint,
			getMenuEndPoint: () => environment.serviceMenuEndPoint,
			getCodeEndPoint: () => environment.serviceCodeEndPoint,
		}),
		SerengetiMarketModule.forRoot({
			createTranslateLoader : createTranslateLoader,
			getLoginEndPoint: () => environment.serviceMemberEndPoint,
			getApplicationEndPoint: () => environment.serviceApplicationCoreEndPoint,
			getBoardEndPoint: () => environment.serviceBoardEndPoint,
			getOrderEndPoint: () => environment.serviceOrderEndPoint,
			getApprovalEndPoint: () => environment.serviceApprovalEndPoint,
			getMarketEndPoint: () => environment.serviceMarketEndPoint,
			getDomainEndPoint : () => environment.serviceDomainEndPoint,
			getEndPoint : () => environment.serviceEndPoint,
			getActiveState: () => true,
			getCategoryRoot: () => 'Marketplace'
		}),
		SerengetiOrderModule.forRoot({
			createTranslateLoader : createTranslateLoader,
			getLoginEndPoint: () => environment.serviceMemberEndPoint,
			getUserEndPoint: () => environment.serviceUserEndPoint,
			getMailEndPoint: () => environment.serviceMailEndPoint,
			getOrderEndPoint: () => environment.serviceOrderEndPoint,
			getApprovalEndPoint: () => environment.serviceApprovalEndPoint,
			getDomainEndPoint: () => environment.serviceDomainEndPoint,
			getEndPoint : () => environment.serviceOrderEndPoint,
			getActiveState: () => true
		}),
		SerengetiMailerModule.forRoot({
			createTranslateLoader : createTranslateLoader,
			getLoginEndPoint: () => environment.serviceMemberEndPoint,
			getUserEndPoint: () => environment.serviceUserEndPoint,
			getMailEndPoint: () => environment.serviceMailEndPoint,
			getConfigEndPoint: () => environment.serviceConfigEndPoint,
			getEndPoint : () => environment.serviceOrderEndPoint,
			getSupportLanguages: () => environment.supportedLanguages,
			getActiveState: () => true
		}),
		SerengetiTokenModule.forRoot({
			createTranslateLoader : createTranslateLoader,
			getEndPoint : () => environment.serviceTokenEndPoint,
			getActiveState: () => true,
			getLoginEndPoint: () => environment.serviceMemberEndPoint
		}),
		SerengetiDatastoreModule.forRoot({
			createTranslateLoader: createTranslateLoader,
			getEndPoint: () => environment.serviceDatastoreEndPoint,
			getDomainEndPoint: () => environment.serviceDomainEndPoint,
			getLoginEndPoint: () => environment.serviceMemberEndPoint,
			getDatastoreEndPoint: () => environment.serviceDatastoreEndPoint,
			getActiveState: () => true,
		}),
		SerengetiMindslabModule.forRoot({
			createTranslateLoader : createTranslateLoader,
			getEndPoint: () => environment.serviceMindsLabEndPoint,
			getLoginEndPoint: () => environment.serviceMemberEndPoint,
			getUserEndPoint: () => environment.serviceUserEndPoint,
			getDomainEndPoint: () => environment.serviceDomainEndPoint,
			getMindslabEndPoint: () => environment.serviceMindsLabEndPoint,
			getActiveState: () => true,
		}),
		SerengetiLoginModule.forRoot({
			createTranslateLoader: createTranslateLoader,
			getLoginEndPoint: () => environment.serviceMemberEndPoint,
			getUserEndPoint: () => environment.serviceUserEndPoint,
			getDomainEndPoint: () => environment.serviceDomainEndPoint,
			getProfile: () => environment.profile
		}),
		SerengetiDashboardModule.forRoot({
			createTranslateLoader: createTranslateLoader,
			getTheme: getConsoleTheme,
			getThemeObserver: () => environment.serviceThemeObject,
			getDashboardEndPoint: () => environment.serviceDashboardEndPoint,
			getLoginEndPoint: () => environment.serviceMemberEndPoint,
			getDomainEndPoint: () => environment.serviceDomainEndPoint,
			getMenuEndPoint: () => environment.serviceMenuEndPoint,
			getContent: () => environment.content,
			getActiveState: () => true,
		}),
		SerengetiTaskModule.forRoot({
			createTranslateLoader: createTranslateLoader,
			getTheme: getConsoleTheme,
			getThemeObserver: () => environment.serviceThemeObject,
			getTaskEndPoint: () => environment.serviceResourceTaskEndPoint,
			getLoginEndPoint: () => environment.serviceMemberEndPoint,
			getCoreEndPoint: () => environment.serviceDomainEndPoint,
			getDomainEndPoint: () => environment.serviceDomainEndPoint,
			getMenuEndPoint: () => environment.serviceMenuEndPoint,
			getContent: () => environment.content,
			getActiveState: () => true,
    	}),
		SerengetiUserModule.forRoot({
			createTranslateLoader: createTranslateLoader,
      		getCloudAccountEndPoint: () => environment.serviceCloudAccountEndPoint,
			getContent: () => environment.content,
			getLoginEndPoint: () => environment.serviceMemberEndPoint,
			getUserEndPoint: () => environment.serviceUserEndPoint,
			getThemeObserver: () => environment.serviceThemeObject,
			getProfile: () => environment.profile
		}),
    SerengetiChatbotModule.forRoot({
      createTranslateLoader : createTranslateLoader,
      getThemeObserver: () => environment.serviceThemeObject,
      getLoginEndPoint: () => environment.serviceMemberEndPoint,
      getChatbotEndPoint: () => environment.serviceChatbotEndPoint,
      getProfile: () => environment.profile,
      getContent: () => environment.content,
      getTheme: getConsoleTheme
    }),
		GridsterModule,
		// SocialLoginModule
	],
	providers: [
		{
			provide: OverlayContainer,
			useClass: FullscreenOverlayContainer
		},
		APP_PROVIDERS,
		StompService,
		ThemeService,
		AppConfigService,
		{
			provide: APP_INITIALIZER,
			useFactory: appInitializerFn,
			multi: true,
			deps: [AppConfigService, ThemeService]
		},
		// {
		// 	provide: AuthServiceConfig,
		// 	useFactory: provideConfig
		// },
		{
			provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' }
		}
	],
	entryComponents: [
		// Setting
		ConsoleCloudAccountPoolSetupDialog,
		ValueInputDialog,

		TaskConfigVariableDialog,

		WizardMarketNewComponent,
		WizardMarketSearchComponent,
		WizardMarketFavoriteComponent,
		WizardMarketDownloadComponent,
		WizardMarketHistoryComponent,
		WizardResourceStatComponent,
		WizardResourceMapComponent,
		WizardResourceCloudComponent,
		WizardNotificationHistoryComponent,
		WizardServiceCalendarComponent,
		WizardOrderStatComponent,
		WizardMonitoringAverageComponent,
		WizardMonitoringProblemsComponent,
		WizardMonitoringDialogComponent,
		WizardApiDummyComponent,
		WizardApiRegisteredComponent,
		WizardUserInfoComponent,
		WizardTestBedComponent
	],
	bootstrap: [
		AppRootComponent
	],
	schemas: [
		CUSTOM_ELEMENTS_SCHEMA
	]
})
export class AppModule {

	constructor() {
	}
}
